import React from 'react';
import { useParams } from 'react-router-dom';
import { Header } from '../Common';
import BulkProduct from '../../Common/BulkProduct';
import { getBulkProduct } from './bulkProductData';
import { SIZE_GUIDE_TITLE, SIZE_GUIDE_ITEMS } from '../Product/sizeGuideData';

const LABELS = {
  sizeTitle: 'Välj storlek',
  sizeGuide: 'Storleksguide',
  infoTemplate: (n) => `Beställ minst ${n} st totalt för att kunna gå vidare.`,
  ctaAdd: 'Lägg i varukorg',
  minError: (n) => `Minst ${n} st totalt`,
  notFound: 'Product not found.',
  riskFreeTitle: 'KÖP RISKFRITT',
  riskFreeDescription: 'Beställ idag. Bestäm dig imorgon. Du har 24 timmar på dig att göra ändringar eller ångra ditt köp.',
  deliveryTime: '3 Veckor',
  deliveryCost: 'Gratis',
  deliveryDescription: 'Leverans till din skola',
};

const ABCSEBulkProduct = () => {
  const { slug } = useParams();
  const product = getBulkProduct(slug);
  return (
    <BulkProduct
      product={product}
      brand="ABC"
      cartBrandSlug="abcse"
      priceSuffix=":-"
      Header={Header}
      labels={LABELS}
      sizeGuide={{ title: SIZE_GUIDE_TITLE, items: SIZE_GUIDE_ITEMS }}
    />
  );
};

export default ABCSEBulkProduct;
